"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgComponent = function SvgComponent(props, ref) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M7.654 1.584L10.44 4.37c.022.02.034.05.034.08s-.012.058-.033.08l-.947.947c-.02.022-.05.034-.08.034s-.058-.01-.08-.033l-.27-.27-1.25 1.252c.3 1.12-.04 2.317-.88 3.115-.073.07-.062.07-.13 0L5.03 7.804l-3.44 2.63 2.63-3.44L2.45 5.22c-.07-.07-.065-.058.005-.132.798-.838 1.994-1.174 3.112-.877l1.25-1.25-.268-.27c-.043-.043-.043-.113 0-.157l.95-.95c.043-.042.114-.042.158 0z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
};

var ForwardRef = /*#__PURE__*/(0, React.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Pin.js.map